export function formatDescription(description: string): string {
  const number = parseFloat(description);
  if (isNaN(number)) return description;
  return number % 1 === 0 ? `${number.toFixed(0)}%` : `${number.toFixed(2)}%`;
}
